var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDermobella(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.697,
    height: 32.712,
    viewBox: "0 0 224.697 32.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 4470,
    "data-name": "Group 4470",
    transform: "translate(-36.847 -234.178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: 1344,
    "data-name": "Rectangle 1344",
    width: 116.205,
    height: 0.57,
    transform: "translate(36.847 234.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4176,
    "data-name": "Contour 4176",
    d: "M0,0H56.176V.293H0Z",
    transform: "translate(181.359 235.296)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: 4252,
    "data-name": "Group 4252",
    transform: "translate(240.577 234.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 4161,
    "data-name": "Contour 4161",
    d: "M736.369,235.665a1.486,1.486,0,1,1-1.486-1.487A1.487,1.487,0,0,1,736.369,235.665Z",
    transform: "translate(-733.396 -234.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4162,
    "data-name": "Contour 4162",
    d: "M758.828,235.665a1.486,1.486,0,1,1-1.486-1.487A1.487,1.487,0,0,1,758.828,235.665Z",
    transform: "translate(-749.284 -234.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4163,
    "data-name": "Contour 4163",
    d: "M779.789,235.665a1.486,1.486,0,1,1-1.486-1.487A1.487,1.487,0,0,1,779.789,235.665Z",
    transform: "translate(-764.112 -234.178)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: 4164,
    "data-name": "Contour 4164",
    d: "M50.771,260.046c4.436,0,7.6.836,9.727,2.908a10.185,10.185,0,0,1,2.909,7.418,11.063,11.063,0,0,1-4.218,9.218c-2.6,2-5.908,2.836-10.127,2.836H40.954v-1.055c3.036-.2,3.308-.364,3.308-3.272V264.374c0-2.909-.272-3.019-2.963-3.255v-1.073Zm-3.835,17.763c0,2.6,1.145,3.272,3.781,3.272,6.709,0,9.654-4.872,9.654-10.273,0-3.436-1.363-6.58-4.254-8.235A11.642,11.642,0,0,0,50.28,261.3a5.52,5.52,0,0,0-2.872.436c-.346.273-.473.6-.473,1.928Z",
    transform: "translate(-2.974 -18.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4165,
    "data-name": "Contour 4165",
    d: "M143.619,276.954c-.164,1.055-.873,4.418-1.181,5.472h-16.6v-1.055c3.163-.236,3.472-.491,3.472-3.308V264.427c0-3-.309-3.09-3.036-3.327v-1.055H141.6c.036.782.164,3.182.291,5.054l-1.109.145a8.158,8.158,0,0,0-1.072-2.964c-.418-.745-1.291-.982-3.745-.982h-2.945c-1.054,0-1.109.091-1.109,1.072v7.763h3.4c3.109,0,3.254-.309,3.655-2.6h1.108v6.582h-1.108c-.473-2.454-.637-2.6-3.655-2.6h-3.4V277.9c0,1.619.273,2.4.873,2.836.673.436,1.854.436,3.654.436,2.6,0,3.6-.272,4.345-1.145a8.479,8.479,0,0,0,1.691-3.2Z",
    transform: "translate(-63.023 -18.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4166,
    "data-name": "Contour 4166",
    d: "M203.893,273.906c-.6-.946-.879-1.206-2.789-1.206h-1.217v5.364c0,2.908.29,3.108,3.108,3.29v1.073h-8.927v-1.073c2.909-.182,3.218-.346,3.218-3.29V264.337c0-2.945-.309-3-3.036-3.236v-1.055h8.436a9.779,9.779,0,0,1,5.326,1.109,5.171,5.171,0,0,1,2.363,4.492c0,3-1.781,4.872-4.381,6.018m-4.292-.145a5.564,5.564,0,0,0,3.782-1.037,4.948,4.948,0,0,0,1.963-4.254c0-3.691-2.564-4.963-5.308-4.963a3.666,3.666,0,0,0-1.855.309c-.309.236-.4.636-.4,1.581v8.365Z",
    transform: "translate(-111.29 -18.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4167,
    "data-name": "Contour 4167",
    d: "M375.384,258.182A11.1,11.1,0,0,1,386.4,269.635c0,7.492-5.2,12.018-11.49,12.018A11.1,11.1,0,0,1,363.876,270.2c0-6.273,4.4-12.018,11.491-12.018Zm-.836,1.364c-3.746,0-7.418,3.091-7.418,9.653,0,6.473,3.708,11.091,8.563,11.091,3.891,0,7.437-3.091,7.437-9.746,0-7.29-4.018-11-8.545-11Z",
    transform: "translate(-231.415 -16.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4168,
    "data-name": "Contour 4168",
    d: "M467.548,251.75c4.094.717,7.423,2.567,7.423,6.984a7.441,7.441,0,0,1-4.232,6.707,17.513,17.513,0,0,1-8.511,1.758h-9.482v-1.364c3.908-.278,4.116-.486,4.116-4.094v-17.6c0-3.562-.185-3.77-3.793-4.07v-1.341h11.124c3.307,0,5.111.509,6.5,1.457a6.168,6.168,0,0,1,2.405,5.065c0,4.093-3.446,5.8-5.55,6.453Zm-5.019-.532c4.764,0,6.915-1.874,6.915-5.527,0-2.8-1.641-5.5-6.106-5.5a6.227,6.227,0,0,0-2.567.439c-.439.3-.6.717-.6,2.174v8.418Zm-2.359,10.477c0,3.146.763,3.908,3.723,3.908,3.84-.046,7.1-1.757,7.1-6.383,0-4.556-3.26-6.36-8.511-6.36H460.17Z",
    transform: "translate(-294.283 -3.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4169,
    "data-name": "Contour 4169",
    d: "M551.288,276.954c-.163,1.055-.873,4.418-1.182,5.472h-16.6v-1.055c3.163-.236,3.472-.491,3.472-3.308V264.427c0-3-.309-3.09-3.035-3.327v-1.055h15.325c.037.782.164,3.182.292,5.054l-1.109.145a8.158,8.158,0,0,0-1.073-2.964c-.418-.745-1.291-.982-3.745-.982h-2.945c-1.055,0-1.109.091-1.109,1.072v7.763h3.4c3.109,0,3.254-.309,3.655-2.6h1.109v6.582h-1.109c-.473-2.454-.637-2.6-3.655-2.6h-3.4V277.9c0,1.619.273,2.4.872,2.836.673.436,1.855.436,3.654.436,2.6,0,3.6-.272,4.346-1.145a8.483,8.483,0,0,0,1.691-3.2Z",
    transform: "translate(-351.414 -18.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4170,
    "data-name": "Contour 4170",
    d: "M618.606,277.027c-.2,1.037-.945,4.345-1.236,5.4H601.862v-1.073c2.872-.182,3.181-.382,3.181-3.29v-13.69c0-2.873-.236-3.036-3.145-3.273v-1.055h8.909V261.1c-2.8.2-3.163.364-3.163,3.273v13.453c0,1.873.2,2.509.835,2.909a7.978,7.978,0,0,0,3.418.436c1.891,0,3.037-.164,3.818-1a9.268,9.268,0,0,0,1.782-3.309Z",
    transform: "translate(-399.77 -18.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4171,
    "data-name": "Contour 4171",
    d: "M682.425,277.027c-.2,1.037-.945,4.345-1.236,5.4H665.682v-1.073c2.872-.182,3.182-.382,3.182-3.29v-13.69c0-2.873-.237-3.036-3.145-3.273v-1.055h8.908V261.1c-2.8.2-3.164.364-3.164,3.273v13.453c0,1.873.2,2.509.837,2.909a7.976,7.976,0,0,0,3.418.436c1.89,0,3.037-.164,3.819-1a9.274,9.274,0,0,0,1.781-3.309Z",
    transform: "translate(-444.917 -18.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4172,
    "data-name": "Contour 4172",
    d: "M742.5,281.108v-1.073c2.326-.273,2.6-.508,2.163-1.835l-1.891-5.2h-7.562c-.51,1.4-.946,2.8-1.456,4.218-.781,2.309-.436,2.582,2.164,2.818v1.073h-7.6v-1.073c2.218-.309,2.691-.473,3.91-3.581l7.055-17.926,1.053-.346c2.091,5.745,4.528,12.636,6.672,18.472.982,2.873,1.492,3.163,3.764,3.381v1.073ZM739.152,262.4h-.073c-1.109,3.037-2.2,6.091-3.272,9.018h6.455Z",
    transform: "translate(-489.225 -16.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4173,
    "data-name": "Contour 4173",
    d: "M228.3,299.756a20.38,20.38,0,0,0,21.525,12.384s-14.241,5.669-22.6-8.257l-1.629-2.7Z",
    transform: "translate(-133.597 -46.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: 4253,
    "data-name": "Group 4253",
    transform: "translate(103.239 241.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 4174,
    "data-name": "Contour 4174",
    d: "M269.481,279.212c.084-1.116.383-2.569.734-6.208l.654-7.159c.292-4.381.2-4.454-2.981-4.745v-1.055H273.4l7.239,17.427,7.851-17.427h6.745V261.1c-3.072.291-3.345.254-3.2,4l.31,12.018c.091,3.817.236,4,3.273,4.236v1.073h-8.927v-1.073c2.873-.236,2.946-.419,2.946-4.236l-.164-13.964H289.4l-7.31,16.254-3.088.008-6.583-15.751h-.072l-.472,9.944c-.164,2.983-.217,4.389-.235,5.652",
    transform: "translate(-266.75 -260.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4175,
    "data-name": "Contour 4175",
    d: "M267,309.613c-.257,1.573-.951,1.908-3,2.11v.836h8.192v-.836c-2.048-.2-3.1-.464-3.209-2.11-.022-.733.028-1.736.065-2.613h-1.642A22.11,22.11,0,0,1,267,309.613Z",
    transform: "translate(-264 -293.262)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDermobella);
export default __webpack_public_path__ + "static/media/logo-dermobella.265f98bbbf2348cf6e8b7f774a32fa0c.svg";
export { ForwardRef as ReactComponent };